var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.area)?_c('avito-area-form',{attrs:{"initial-area":_vm.area}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }